<template>
    <div class="my-feedback">
        
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="getPageList"
            >
                <div class="feedback-container ">
                    <div class="feedback-content">
                        <div class="feedback-list" v-for="(item, index) in list" :key="index" @click="$router.push({path: '/feedback/feedbackDetail/'+isAdmin, query: {id: item.id}})">
                            <div class="list-type">
                                <span v-if="item.feedbackType === 2" class="list-type-button button-green">{{item.feedbackTypeName}}</span>
                                <span v-if="item.feedbackType === 1" class="list-type-button button-yellow">{{item.feedbackTypeName}}</span>
                                <span v-if="item.feedbackType === 0" class="list-type-button button-red">{{item.feedbackTypeName}}</span>
                                {{item.feedbackContent}}
                            </div>
                            <div class="list-date">
                                <span>{{item.createTime}}</span>
                                <span v-if="item.isReply" class="list-status">已回复</span>
                                <span v-if="!item.isReply" class="status">未回复</span>
                            </div>
                        </div>
                    </div>
                </div> 
            </van-list>
        </van-pull-refresh>
    </div>
    
</template>

<script>
    import api from '../../service/modules/feedback'
    export default {
        name: 'MyFeedback',
        data() {
            return {
                list: [],
                loading: false,
                finished: false,
                refreshing: false,
                total: null,
                admin: false,
                fromVaiteFiled: {
                    page: 1, 
                    size: 10,
                    isReply: 2
                }
            }
        },
        components: {
            
        },
        computed: {

        },
        watch: {
            filterReadList: {
                handler(oldVal, newVal) {
                    const val = newVal.filter(item => item.check)[0].isReply
                    console.log(this)
                    if (val !== this.fromVaiteFiled.isReply && !this.isAdmin) {
                        this.fromVaiteFiled.page = 1;
                        this.finished = false;
                        this.list = [];
                        this.total = null;
                        this.fromVaiteFiled.isReply = val;
                        this.getPageList();
                    }
                },
                deep: true
            },
        },
        props: {
            filterReadList: {
                type: Array,
                default: () => []
            },
            isAdmin: {
                type: Boolean,
                default: () => true
            },
            componentIndex: {
                type: Number,
                default: () => 0
            }
        },
        methods: {
            onRefresh() {
                this.fromVaiteFiled.page = 1;
                this.list = [];
                // 清空列表数据
                this.finished = false;

                // 重新加载数据
                // 将 loading 设置为 true，表示处于加载状态
                this.loading = true;
                this.getPageList();
            },
            getPageList() {
                if (this.list.length == this.total) {
                        return this.finished = true;
                }
                let ajax;
                if (this.isAdmin) {
                    this.fromVaiteFiled.isReply = null;
                    ajax = api.AdminPageList
                } else {
                    ajax = api.pageList
                }
                ajax(this.fromVaiteFiled).then(res => {
                    this.total = res.data.total
                    this.fromVaiteFiled.page++
                    const list = res.data.records.map(item => {
                        if (item.feedbackType === 0) {
                            item.feedbackTypeName = '账号问题'
                        } else if (item.feedbackType === 1) {
                            item.feedbackTypeName = '平台性能'
                        } else if (item.feedbackType === 2) {
                            item.feedbackTypeName = '产品意见'
                        }
                        return item
                    })
                    if (this.refreshing) {
                        this.refreshing = false;
                    }
                    this.loading = false;
                    
                    this.list = Array.from(new Set([...this.list, ...list]))
                })
                
            },

            
        },
        created() {
            // if (!this.isAdmin) {
            //     this.getPageList()
            // }
            // this.getPageList()
        },
        mounted() {
            
        },
        // activated() {
        //     this.onRefresh()
        // }
    }
</script>

<style lang="less" scoped>
    ::-webkit-scrollbar {
    display: none; /* Chrome Safari */
    }

    .my-feedback{
        width: 100%;
        // background: rgba(251, 251, 251, 1);
        box-sizing: border-box;
        // padding-bottom: 90px;
        font-family: PingFangSC-Regular;
        // padding-top: 56px;

        .feedback-container{
            display: flex;
            padding: 0 16px;
            margin-bottom: 24px;
        }

        .feedback-content{
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            background-color: #fff;
            box-sizing: border-box;
            margin-top: 12px;
            border-radius: 4px;
            padding: 4px 16px;
            padding-bottom: 24px;
        }

        .feedback-list{
            width: 100%;
            display: flex;
            padding: 19.5px 0;
            border-bottom: 1px solid #F8F9FB;
            flex-wrap: wrap;
            &:last-child{
                border-bottom: none;
                padding-bottom: 0;
            }
            .list-type{
                word-break: break-all;
                font-size: 14px;
                color: #171A1D;
                max-height: 56px;
                overflow: hidden;
                line-height: 28px;
                // display: flex;
                .list-type-button{
                    line-height: 12px;
                    display: inline-block;
                    padding: 4px 4px;
                    box-sizing: border-box;
                    border-radius: 2px;
                    text-align: center;
                    color: #36B374;
                    border: solid #36B374 0.5px;
                    // background: rgba(54,179,116,0.05);
                    font-size: 12.5px;
                    transform: scale(0.8);
                    margin-left: -6px;
                }
                .button-green{
                    color: #36B374;
                    border: solid #36B374 0.5px;
                }
                .button-yellow{
                    color: #FF8C19;
                    border: solid #FF8C19 0.5px;
                }
                .button-red{
                    color: #FF4D4D;
                    border: solid #FF4D4D 0.5px;
                }
                span:nth-child(2){
                    font-size: 14px;
                    color: #171A1D;
                    line-height: 28px;
                    overflow: hidden;
                }
            }
            .list-date{
                width: 100%;
                display: flex;
                justify-content: space-between;
                font-size: 12px;
                margin-top: 16px;
                span:nth-child(1){
                    color: #A2A3A4;
                }
                .list-status{
                    color: #36B374;
                }
                .status {
                    color: #A2A3A4;
                }
            }
        }
    }
</style>